import * as React from "react";
import { chainIdHex, rpcUrl } from "../constants";

export function useChangeNetwork(): () => Promise<any> {
  const changeNetwork = React.useCallback(() => {
    const { ethereum } = window as any;
    if (ethereum) {
      return ethereum
        .request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: chainIdHex }],
        })
        .catch((switchError: any) => {
          if (switchError.code === 4902) {
            ethereum
              .request({
                method: "wallet_addEthereumChain",
                params: [
                  {
                    chainId: chainIdHex,
                    chainName: "Avalanche Network",
                    nativeCurrency: {
                      name: "Avalanche",
                      symbol: "AVAX",
                      decimals: 18,
                    },
                    rpcUrls: [rpcUrl],
                    blockExplorerUrls: [
                      "https://cchain.explorer.avax.network/",
                    ],
                  },
                ],
              })
              .catch(console.error);
          }
        });
    }
  }, []);

  return changeNetwork;
}
